/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import DefaultEmbedConstants from 'constants/DefaultEmbedConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'
import { patchOperations } from 'utils/PatchHelper'
import store from 'containers/store'
import { patchEmbedSuccess } from 'app/modules/embed/actions'

const DefaultEmbedQueries = Marty.createQueries({
  id: 'DefaultEmbedQueries',

  fetchDefaultEmbed(orgId) {
    const promise = this.app.sources.DefaultEmbedAPI.fetchDefaultEmbed(orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_FETCH_DONE, orgId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_FETCH_FAILED, orgId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_FETCH_FAILED, orgId, error)
    })
  },

  updateDefaultEmbed(configuration, notificationMessage) {
    const operations = patchOperations(configuration, {})
    return this.patchDefaultEmbed(operations, notificationMessage)
  },

  patchDefaultEmbed(operations, notificationMessage) {
    this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_START, {})
    const promise = this.app.sources.DefaultEmbedAPI.patchDefaultEmbed(operations)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_DONE, res.body)
        store.dispatch(patchEmbedSuccess(res.body))
        if (notificationMessage) {
          return this.app.actions.NotificationActions.pushNotification({
            content: notificationMessage
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_FAILED, operations, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_FAILED, operations, res)
    })
  },

  refreshDefaultEmbed(orgId) {
    return this.app.sources.DefaultEmbedAPI.refreshDefaultEmbed(orgId).then(res => {
      if (res.status === 200) {
        return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_REFRESH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_REFRESH_FAILED, orgId)
      }
    }).catch(error => {
      captureException(error)
      return this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_REFRESH_FAILED, orgId)
    })
  }
})

export default DefaultEmbedQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/DefaultEmbedQueries.js